import GlobalActionTypes from './global.types';

export const setCurrentPath = (newPath) => ({
  type: GlobalActionTypes.SET_CURRENT_PATH,
  payload: newPath
});

export const toggleSidebarHidden = () => ({
  type: GlobalActionTypes.TOGGLE_SIDEBAR_HIDDEN
});

export const selectCustomerInformation = (customerInfo) => ({
  type: GlobalActionTypes.SELECT_CUSTOMER_INFORMATION,
  payload: customerInfo
});

export const setAuthenticated = (payload) => ({
  type: GlobalActionTypes.SET_AUTHENTICATED,
  payload: payload
});

export const setUser = (payload) => ({
  type: GlobalActionTypes.SET_USER,
  payload: payload
});

export const logout = (payload) => ({
  type: GlobalActionTypes.LOGOUT,
  payload: payload
});
